import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
const bqGetProgramList = async function(owner) {

  const app = firebase.app();
  const functions = getFunctions(app, 'asia-east2');
  const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');

  let result = [];
  if( owner ){
    result = await queryThaisookViewBigQuery({
        info: 'get programList',
        query: `
            with programData as (
                select
                    P.programId,
                    P.owner,
                    P.name,
                    concat(U.firstname, ' ', U.lastname) coach_name,
                    coachList,
                    O.name Org
                from
                    thaisook_view.program P
                    join thaisook_view.users U on U.uid = P.owner
                    left join thaisook_view.organization O on O.orgId = U.orgId
            ),
            memberCount as (
                select programId, COUNT(1) member_count from thaisook_view.program_members group by programId
            ),
            programMember as (
                select
                    programId, 
                    uid, 
                    startDate,
                    onsiteCount,
                    IF( startDate is not null, 
                        if( endDate is not null, endDate, current_date()),
                        endDate
                    ) endDate
                from 
                    thaisook_view.program_members
            ),
            dataHealthdata as (
                SELECT 
                    programMember.programId, 
                    count(*) data
                FROM 
                    programMember
                    join thaisook_view.healthdata HD on programMember.uid = HD.uid
                where 
                    date(HD.date) between date(programMember.startDate) and date(programMember.endDate)
                group by 
                    programMember.programId
            ),
            dataSleep as (
                SELECT 
                    programMember.programId, 
                    count(*) data
                FROM 
                    programMember
                    join activity_view.sleep HD on programMember.uid = HD.uid
                where 
                    date(HD.date) between date(programMember.startDate) and date(programMember.endDate)
                group by 
                    programMember.programId
            ),
            dataWorkout as (
                SELECT 
                    programMember.programId, 
                    count(*) data
                FROM 
                    programMember
                    join activity_view.workout HD on programMember.uid = HD.uid
                where 
                    date(HD.date) between date(programMember.startDate) and date(programMember.endDate)
                group by 
                    programMember.programId
            ),
            dataWater as (
                SELECT 
                    programMember.programId, 
                    count(*) data
                FROM 
                    programMember
                    join activity_view.water HD on programMember.uid = HD.uid
                where 
                    date(HD.date) between date(programMember.startDate) and date(programMember.endDate)
                group by 
                    programMember.programId
            ),
            dataFood as (
                SELECT 
                    programMember.programId, 
                    count(*) data
                FROM 
                    programMember
                    join activity_view.food HD on programMember.uid = HD.uid
                where 
                    date(HD.date) between date(programMember.startDate) and date(programMember.endDate)
                group by 
                    programMember.programId
            ),
            programActivity as (
                select 
                    programdata.programId,
                    (dataHealthdata.data + dataSleep.data + dataWorkout.data + dataWater.data + dataFood.data) activityCount
                from programData 
                    left join dataHealthdata 
                        on dataHealthdata.programId = programData.programId
                    left join dataSleep 
                        on dataSleep.programId = programData.programId
                    left join dataWorkout 
                        on dataWorkout.programId = programData.programId
                    left join dataWater 
                        on dataWater.programId = programData.programId
                    left join dataFood 
                        on dataFood.programId = programData.programId
            ),
            programOnsite as (
              select 
                  programMember.programId, 
                  sum(programMember.onsiteCount) as onsiteCount 
              from 
                  programMember 
              group by 
                  programMember.programId 
            )
            select 
                programData.programId id,
                programData.owner,
                programData.name,
                programData.Org,
                programData.coach_name, 
                memberCount.member_count,
                programData.coachList,
                cast((programActivity.activityCount/memberCount.member_count) as int64) activityCount,
                cast((programOnsite.onsiteCount/memberCount.member_count) as int64)as onsiteCount
            from 
                programData 
                left join memberCount 
                    on memberCount.programId = programData.programId
                left join programActivity 
                    on programActivity.programId = programData.programId
                left join programOnsite
                    on programOnsite.programId = programData.programId 
            where 
                programData.owner = '${owner}' 
                or '${owner}' in unnest(coachList)
                `
    });
  }else{
    result = await queryThaisookViewBigQuery({
        info: 'get programList',
        query: `
        with programData as (
            select
                P.programId,
                P.owner,
                P.name,
                concat(U.firstname, ' ', U.lastname) coach_name,
                coachList,
                O.name Org
            from
                thaisook_view.program P
                join thaisook_view.users U on U.uid = P.owner
                left join thaisook_view.organization O on O.orgId = U.orgId
        ),
        memberCount as (
            select programId, COUNT(1) member_count from thaisook_view.program_members group by programId
        ),
        programMember as (
            select
                programId, 
                uid, 
                startDate,
                onsiteCount,
                IF( startDate is not null, 
                    if( endDate is not null, endDate, current_date()),
                    endDate
                ) endDate
            from 
                thaisook_view.program_members
        ),
        dataHealthdata as (
            SELECT 
                programMember.programId, 
                count(*) data
            FROM 
                programMember
                join thaisook_view.healthdata HD on programMember.uid = HD.uid
            where 
                date(HD.date) between date(programMember.startDate) and date(programMember.endDate)
            group by 
                programMember.programId
        ),
        dataSleep as (
            SELECT 
                programMember.programId, 
                count(*) data
            FROM 
                programMember
                join activity_view.sleep HD on programMember.uid = HD.uid
            where 
                date(HD.date) between date(programMember.startDate) and date(programMember.endDate)
            group by 
                programMember.programId
        ),
        dataWorkout as (
            SELECT 
                programMember.programId, 
                count(*) data
            FROM 
                programMember
                join activity_view.workout HD on programMember.uid = HD.uid
            where 
                date(HD.date) between date(programMember.startDate) and date(programMember.endDate)
            group by 
                programMember.programId
        ),
        dataWater as (
            SELECT 
                programMember.programId, 
                count(*) data
            FROM 
                programMember
                join activity_view.water HD on programMember.uid = HD.uid
            where 
                date(HD.date) between date(programMember.startDate) and date(programMember.endDate)
            group by 
                programMember.programId
        ),
        dataFood as (
            SELECT 
                programMember.programId, 
                count(*) data
            FROM 
                programMember
                join activity_view.food HD on programMember.uid = HD.uid
            where 
                date(HD.date) between date(programMember.startDate) and date(programMember.endDate)
            group by 
                programMember.programId
        ),
        programActivityList as (
            select programId, data from dataHealthdata
            union all
            select programId, data from dataSleep
            union all
            select programId, data from dataWorkout
            union all
            select programId, data from dataWater
            union all
            select programId, data from dataFood
        ),
        programActivity as (
            select programId, sum(data) as activityCount from programActivityList group by programId
        ),
        programOnsite as (
          select 
              programMember.programId, 
              sum(programMember.onsiteCount) as onsiteCount 
          from 
              programMember 
          group by 
              programMember.programId 
        )
        select 
            programData.programId id,
            programData.owner,
            programData.name,
            programData.Org,
            programData.coach_name, 
            memberCount.member_count,
            programData.coachList,
            cast((programActivity.activityCount/memberCount.member_count) as NUMERIC) activityCount,
            cast((programOnsite.onsiteCount/memberCount.member_count) as int64)as onsiteCount
        from 
            programData 
            left join memberCount 
                on memberCount.programId = programData.programId
            left join programActivity 
                on programActivity.programId = programData.programId
            left join programOnsite
                on programOnsite.programId = programData.programId 
            `
    });
  }

  const resultObj = JSON.parse(result.data);
  return resultObj
};
export default bqGetProgramList;
